// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 28Wh6oQMGtkZtGs1aVzLHN
// Component: C1uLLNnyhZEL
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import HomepageNavbar from "../../HomepageNavbar"; // plasmic-import: xTJEhzpCCql/component
import Button from "../../Button"; // plasmic-import: -J7uJC61H3oz/component
import ZakazivanjeBtn from "../../ZakazivanjeBtn"; // plasmic-import: brU4_XM4GK/component
import SlikaText from "../../SlikaText"; // plasmic-import: 3kgVYjq7oe/component
import HomepageFooter from "../../HomepageFooter"; // plasmic-import: lnNBtyPw6r3/component
import { useScreenVariants as useScreenVariantsjSnjRsWLwTjq } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: JSnjRsWLwTjq/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_origin.module.css"; // plasmic-import: 28Wh6oQMGtkZtGs1aVzLHN/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: C1uLLNnyhZEL/css
import _4SanijpgP1ZoHaA2E from "../bela_griva/images/_4Sanijpg.jpg"; // plasmic-import: p1ZoHaA2E/picture
import img7247Jpg2CkxdByVb from "../bela_griva/images/img7247Jpg.jpg"; // plasmic-import: 2ckxdByVB/picture
import img7146Jpg77KWsSvpt from "../bela_griva/images/img7146Jpg.jpg"; // plasmic-import: 77kWSSvpt/picture
import img7318JpgTeJxfmIgw from "../bela_griva/images/img7318Jpg.jpg"; // plasmic-import: teJXFMIgw/picture
import image2LhqDznIcG from "../bela_griva/images/image2.jpg"; // plasmic-import: lhqDZNIcG/picture
import _3SaracjpgUn1Z8GiIy from "../bela_griva/images/_3Saracjpg.jpg"; // plasmic-import: UN1Z8GiIy/picture
import _1BraonKonjjpgSoCydcr6G from "../bela_griva/images/_1BraonKonjjpg.jpg"; // plasmic-import: SoCydcr6G/picture

export const PlasmicHomepage__VariantProps = new Array("unnamedVariant");

export const PlasmicHomepage__ArgProps = new Array();

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());

const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const [$queries, setDollarQueries] = React.useState({});
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "unnamedVariant",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.unnamedVariant
      }
    ],

    [$props, $ctx]
  );

  const $state = p.useDollarState(stateSpecs, { $props, $ctx, $queries });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsjSnjRsWLwTjq()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root,
            {
              [sty.rootunnamedVariant]: hasVariant(
                $state,
                "unnamedVariant",
                "unnamedVariant"
              )
            }
          )}
        >
          {true ? (
            <HomepageNavbar
              data-plasmic-name={"homepageNavbar"}
              data-plasmic-override={overrides.homepageNavbar}
              className={classNames("__wab_instance", sty.homepageNavbar, {
                [sty.homepageNavbarunnamedVariant]: hasVariant(
                  $state,
                  "unnamedVariant",
                  "unnamedVariant"
                )
              })}
              unnamedVariant={
                hasVariant($state, "unnamedVariant", "unnamedVariant")
                  ? true
                  : undefined
              }
            />
          ) : null}
          <div
            data-plasmic-name={"hero"}
            data-plasmic-override={overrides.hero}
            className={classNames(projectcss.all, sty.hero)}
          >
            <div className={classNames(projectcss.all, sty.columns___7SaDt)}>
              <div className={classNames(projectcss.all, sty.column__vDyml)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__yQqrZ
                  )}
                >
                  {
                    "Pocetnik, rekreativac ili iskusan jahač, u skoli jahanja Bela Griva možete da postanete bolji"
                  }
                </div>
                <Button
                  data-plasmic-name={"button"}
                  data-plasmic-override={overrides.button}
                  className={classNames("__wab_instance", sty.button, {
                    [sty.buttonunnamedVariant]: hasVariant(
                      $state,
                      "unnamedVariant",
                      "unnamedVariant"
                    )
                  })}
                  link={
                    hasVariant($state, "unnamedVariant", "unnamedVariant")
                      ? "tel:+381612439221"
                      : "tel:+381612439221"
                  }
                  submitsForm={true}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__m1Iip
                    )}
                  >
                    {"POZOVI I ZAKAŽI JAHANJE"}
                  </div>
                </Button>
              </div>
              <div className={classNames(projectcss.all, sty.column__uKVz)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__aMkMx)}
                >
                  {true ? (
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___2UgUf
                      )}
                    >
                      <p.PlasmicImg
                        alt={""}
                        className={classNames(sty.img___6CuW)}
                        displayHeight={"415px"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"466px"}
                        loading={"lazy"}
                        src={{
                          src: _4SanijpgP1ZoHaA2E,
                          fullWidth: 4680,
                          fullHeight: 3120,
                          aspectRatio: undefined
                        }}
                      />
                    </div>
                  ) : null}
                </p.Stack>
              </div>
            </div>
          </div>
          <p.Stack
            as={"div"}
            data-plasmic-name={"jahanjeZaDecuIOdraske"}
            data-plasmic-override={overrides.jahanjeZaDecuIOdraske}
            hasGap={true}
            className={classNames(projectcss.all, sty.jahanjeZaDecuIOdraske)}
          >
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__oLe8Y)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__uWlWh)}>
                <h2
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.h2__zBDg
                  )}
                >
                  {"Jahanje za  decu i odrasle na Beogradskom Hipodromu"}
                </h2>
              </div>
            </p.Stack>
            <div
              data-plasmic-name={"upoznajKonje2"}
              data-plasmic-override={overrides.upoznajKonje2}
              className={classNames(projectcss.all, sty.upoznajKonje2)}
            >
              <div className={classNames(projectcss.all, sty.columns__nT6O4)}>
                <div className={classNames(projectcss.all, sty.column__bLXlN)}>
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img__yqIjd)}
                    displayHeight={"472px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"649px"}
                    loading={"lazy"}
                    src={{
                      src: img7247Jpg2CkxdByVb,
                      fullWidth: 3120,
                      fullHeight: 4680,
                      aspectRatio: undefined
                    }}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__hevif)}>
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img__sGskr)}
                    displayHeight={"472px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"649px"}
                    loading={"lazy"}
                    src={{
                      src: img7146Jpg77KWsSvpt,
                      fullWidth: 2921,
                      fullHeight: 4382,
                      aspectRatio: undefined
                    }}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__fUtp4)}>
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img___4Txag)}
                    displayHeight={"472px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"649px"}
                    loading={"lazy"}
                    src={{
                      src: img7318JpgTeJxfmIgw,
                      fullWidth: 4474,
                      fullHeight: 2983,
                      aspectRatio: undefined
                    }}
                  />
                </div>
              </div>
            </div>
          </p.Stack>
          <p.Stack
            as={"div"}
            data-plasmic-name={"sekcija3PlavoOdJutra"}
            data-plasmic-override={overrides.sekcija3PlavoOdJutra}
            hasGap={true}
            className={classNames(projectcss.all, sty.sekcija3PlavoOdJutra)}
          >
            <div
              className={classNames(projectcss.all, sty.columns___9A7K6, {
                [sty.columnsunnamedVariant___9A7K6A6O6E]: hasVariant(
                  $state,
                  "unnamedVariant",
                  "unnamedVariant"
                )
              })}
            >
              <div
                className={classNames(projectcss.all, sty.column__lvGYs, {
                  [sty.columnunnamedVariant__lvGYsa6O6E]: hasVariant(
                    $state,
                    "unnamedVariant",
                    "unnamedVariant"
                  )
                })}
              >
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__epVxI)}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__o26Ab)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__lxNo2)}
                    >
                      <h2
                        className={classNames(
                          projectcss.all,
                          projectcss.h2,
                          projectcss.__wab_text,
                          sty.h2__y4Izh
                        )}
                      >
                        {"Jahanje kao stil zivota"}
                      </h2>
                    </div>
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__mXtE3,
                        {
                          [sty.textunnamedVariant__mXtE3A6O6E]: hasVariant(
                            $state,
                            "unnamedVariant",
                            "unnamedVariant"
                          )
                        }
                      )}
                    >
                      {
                        "Skola Jahanja Bela griva je otvorena   cele nedelje sem ponedeljkom. \n\nJašemo na konjima i ponijima odabranim zbog njihovog bezbednog temperamenta, za jahače svih sposobnosti. Prethodno iskustvo nije neophodno"
                      }
                    </div>
                    <Button
                      data-plasmic-name={"pogledajteNaseCene"}
                      data-plasmic-override={overrides.pogledajteNaseCene}
                      className={classNames(
                        "__wab_instance",
                        sty.pogledajteNaseCene
                      )}
                      color={"unnamedVariant"}
                      link={
                        "https://docs.google.com/spreadsheets/d/1N6MOwYAPcV7qaXd1K7MCubraNW3JAqVk0KnNuw_M8QE/edit?usp=sharing"
                      }
                      submitsForm={true}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__faD5G
                        )}
                      >
                        {"Pogledajte Cenovnik"}
                      </div>
                    </Button>
                  </p.Stack>
                </p.Stack>
              </div>
              <div
                className={classNames(projectcss.all, sty.column__vhCyJ, {
                  [sty.columnunnamedVariant__vhCyJa6O6E]: hasVariant(
                    $state,
                    "unnamedVariant",
                    "unnamedVariant"
                  )
                })}
              >
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__k3Vfx)}
                  displayHeight={"404px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"684px"}
                  loading={"lazy"}
                  src={{
                    src: image2LhqDznIcG,
                    fullWidth: 4680,
                    fullHeight: 3120,
                    aspectRatio: undefined
                  }}
                />
              </div>
            </div>
            {(
              hasVariant($state, "unnamedVariant", "unnamedVariant")
                ? true
                : hasVariant(globalVariants, "screen", "mobileOnly")
                ? true
                : true
            ) ? (
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__sJrHf,
                  {
                    [sty.textunnamedVariant__sJrHfa6O6E]: hasVariant(
                      $state,
                      "unnamedVariant",
                      "unnamedVariant"
                    )
                  }
                )}
              >
                {"Enter some text"}
              </div>
            ) : null}
          </p.Stack>
          <p.Stack
            as={"div"}
            data-plasmic-name={"callToAction"}
            data-plasmic-override={overrides.callToAction}
            hasGap={true}
            className={classNames(projectcss.all, sty.callToAction)}
          >
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__neRj, {
                [sty.freeBoxunnamedVariant__neRja6O6E]: hasVariant(
                  $state,
                  "unnamedVariant",
                  "unnamedVariant"
                )
              })}
            >
              <div className={classNames(projectcss.all, sty.columns__e3XWj)}>
                <div
                  className={classNames(projectcss.all, sty.column__eGljD, {
                    [sty.columnunnamedVariant__eGljDa6O6E]: hasVariant(
                      $state,
                      "unnamedVariant",
                      "unnamedVariant"
                    )
                  })}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2___82U,
                      {
                        [sty.h2unnamedVariant___82UA6O6E]: hasVariant(
                          $state,
                          "unnamedVariant",
                          "unnamedVariant"
                        )
                      }
                    )}
                  >
                    {
                      "Zelite da  jasete konja ili ponija na Hipodromu, kao zabavu po trkackim stazama, u mnajezu ili zelite kurs i obuku jahanja?"
                    }
                  </h2>
                </div>
                <div
                  className={classNames(projectcss.all, sty.column__z0CIr, {
                    [sty.columnunnamedVariant__z0CIra6O6E]: hasVariant(
                      $state,
                      "unnamedVariant",
                      "unnamedVariant"
                    )
                  })}
                >
                  {(
                    hasVariant($state, "unnamedVariant", "unnamedVariant")
                      ? true
                      : true
                  ) ? (
                    <ZakazivanjeBtn
                      className={classNames(
                        "__wab_instance",
                        sty.zakazivanjeBtn__wmmf1,
                        {
                          [sty.zakazivanjeBtnunnamedVariant__wmmf1A6O6E]:
                            hasVariant(
                              $state,
                              "unnamedVariant",
                              "unnamedVariant"
                            )
                        }
                      )}
                    />
                  ) : null}
                  {(
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? true
                      : true
                  ) ? (
                    <ZakazivanjeBtn
                      className={classNames(
                        "__wab_instance",
                        sty.zakazivanjeBtn__ywCy3
                      )}
                    />
                  ) : null}
                  {(
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? true
                      : true
                  ) ? (
                    <ZakazivanjeBtn
                      className={classNames(
                        "__wab_instance",
                        sty.zakazivanjeBtn__gp4Nh
                      )}
                    />
                  ) : null}
                </div>
              </div>
            </p.Stack>
          </p.Stack>
          <div
            data-plasmic-name={"upoznajKonje"}
            data-plasmic-override={overrides.upoznajKonje}
            className={classNames(projectcss.all, sty.upoznajKonje)}
          >
            <div className={classNames(projectcss.all, sty.columns__nuDtq)}>
              <div className={classNames(projectcss.all, sty.column___0IZwz)}>
                <SlikaText
                  className={classNames("__wab_instance", sty.slikaText__cSOkH)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___2ViP
                    )}
                  >
                    {"Sani"}
                  </div>
                </SlikaText>
              </div>
              <div className={classNames(projectcss.all, sty.column__zVg45)}>
                <SlikaText
                  className={classNames("__wab_instance", sty.slikaText__e487U)}
                  imgUrl={{
                    src: _3SaracjpgUn1Z8GiIy,
                    fullWidth: 854,
                    fullHeight: 907,
                    aspectRatio: undefined
                  }}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___5LvAz
                    )}
                  >
                    {"Šarac"}
                  </div>
                </SlikaText>
              </div>
              <div className={classNames(projectcss.all, sty.column___0OVbO)}>
                <SlikaText
                  className={classNames("__wab_instance", sty.slikaText__kTi1P)}
                  imgUrl={{
                    src: _1BraonKonjjpgSoCydcr6G,
                    fullWidth: 3558,
                    fullHeight: 3120,
                    aspectRatio: undefined
                  }}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__g1U4O
                    )}
                  >
                    {"Katalea"}
                  </div>
                </SlikaText>
              </div>
            </div>
          </div>
          <HomepageFooter
            data-plasmic-name={"homepageFooter"}
            data-plasmic-override={overrides.homepageFooter}
            className={classNames("__wab_instance", sty.homepageFooter, {
              [sty.homepageFooterunnamedVariant]: hasVariant(
                $state,
                "unnamedVariant",
                "unnamedVariant"
              )
            })}
          />
        </p.Stack>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "homepageNavbar",
    "hero",
    "button",
    "jahanjeZaDecuIOdraske",
    "upoznajKonje2",
    "sekcija3PlavoOdJutra",
    "pogledajteNaseCene",
    "callToAction",
    "upoznajKonje",
    "homepageFooter"
  ],

  homepageNavbar: ["homepageNavbar"],
  hero: ["hero", "button"],
  button: ["button"],
  jahanjeZaDecuIOdraske: ["jahanjeZaDecuIOdraske", "upoznajKonje2"],
  upoznajKonje2: ["upoznajKonje2"],
  sekcija3PlavoOdJutra: ["sekcija3PlavoOdJutra", "pogledajteNaseCene"],
  pogledajteNaseCene: ["pogledajteNaseCene"],
  callToAction: ["callToAction"],
  upoznajKonje: ["upoznajKonje"],
  homepageFooter: ["homepageFooter"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    homepageNavbar: makeNodeComponent("homepageNavbar"),
    hero: makeNodeComponent("hero"),
    button: makeNodeComponent("button"),
    jahanjeZaDecuIOdraske: makeNodeComponent("jahanjeZaDecuIOdraske"),
    upoznajKonje2: makeNodeComponent("upoznajKonje2"),
    sekcija3PlavoOdJutra: makeNodeComponent("sekcija3PlavoOdJutra"),
    pogledajteNaseCene: makeNodeComponent("pogledajteNaseCene"),
    callToAction: makeNodeComponent("callToAction"),
    upoznajKonje: makeNodeComponent("upoznajKonje"),
    homepageFooter: makeNodeComponent("homepageFooter"),
    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
